import { runInAction, makeAutoObservable } from "mobx";
import { callRemoteMethod } from "../utils/WebserviceHandler";
import CONSTANTS from "../utils/constants";
import { makePersistable } from "mobx-persist-store";

import { ErrorWrapper, setValues } from "../utils/ErrorWrapper";
import moment from "moment";
import User from "./UserStore";
import axios from "axios";
import { NotifyError } from "../utils/ShowError";

interface Bill {
  id: number;
  accountNumber: String | null;
  paymentDate: String | null;
  paymentReference: String | null;
  premiseDetails: String | null;
  customerName: String | undefined;
  paymentStatus: String | null;
}

interface Obj {
  [key: string]: any;
}

class General {
  premise: Obj = {};
  notificationConfig: Obj = {};
  isLargeScreen: Boolean = false;
  registrationDetails: Obj = {};
  registrationStatus: Obj = {};
  token: string = "";
  screenReader: boolean = false;
  ColorAss: string = "#101E8E";
  colorClass: any = null;
  textClass: any = null;
  otp: string = "";
  latTimeStamp: any = "";
  otpResult: Obj = {};
  otpUserData: Obj = {};
  makani: Obj = {};
  ajmanUser: Obj = {};
  fzUser: Obj = {};
  emirate: Obj = {};
  dashboard: Obj = {};
  codeLabels: Obj = {};
  accessibility: Obj = { fontSize: 1 };
  contrast: Obj = {};
  paymentUpdateResponse: Obj = {};
  recentRequests: Obj[] = [];
  commonlyUsedServices: Obj[] = [];
  services: Obj[] = [];
  notifications: {
    count: number;
    list: Obj[];
  } = {
    count: 0,
    list: [],
  };

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true, deep: true }); //persist

    makePersistable(this, {
      name: "general",
      properties: ["token", "codeLabels", "otpUserData", "premise"],
      storage: window.localStorage,
    });

    makePersistable(this, {
      name: "premise",
      properties: ["premise"],
      storage: window.localStorage,
    });
    makePersistable(this, {
      name: "otpUserData",
      properties: ["otpUserData"],
      storage: window.localStorage,
    });
  }

  handleAccessibility = ({
    text,
    backGround,
  }: {
    text: any;
    backGround: any;
  }) => {
    runInAction(() => {
      this.accessibility = {
        ...this.accessibility,
        fontSize: text,
        backGround,
      };
    });
  };
  handleContrast = ({
    contrastColor,
    contrastBackground,
  }: {
    contrastColor: any;
    contrastBackground: any;
  }) => {
    runInAction(() => {
      this.contrast = {
        ...this.accessibility,
        contrastBackground,
        contrastColor,
      };
    });
  };

  handleColorClick = ({
    type,
    colorClass,
    textClass,
  }: {
    type: string;
    colorClass: any;
    textClass: any;
  }) => {
    console.log(type);
    console.log(colorClass);
    console.log(textClass);
    runInAction(() => {
      this.ColorAss = type;
      this.colorClass = colorClass;
      this.textClass = textClass;
    });
  };

  setLargeScreen = (isLarge: Boolean) => {
    runInAction(() => {
      this.isLargeScreen = isLarge;
    });
  };

  handleScreenReader = ({ type }: { type: boolean }) => {
    runInAction(() => {
      this.screenReader = type;
    });
  };

  handlePremiseDetails = ErrorWrapper(async (id: any) => {
    const data = {
      premiseId: id?.premiseId,
      recaptchaToken: id?.recaptchaToken,
      platform: id?.platform
    };
    //  console.log("premise data consoled", data);
    this.premise = {};

    const res = await callRemoteMethod({
      endpoint: CONSTANTS.URL.GET_PREMISE,
      type: "GET",
      data,
    });
    runInAction(() => {
      this.premise = { ...res.result };
    });
    return res?.result;
  });

  handleBackClick = () => {
    runInAction(() => {
      this.premise = {};
      this.otpUserData = {};
    });
  };

  handlePremiseDetailsNoToken = ErrorWrapper(async (id: any) => {
    const data = {
      premiseId: id?.premiseId,
      recaptchaToken: id?.recaptchaToken,
      platform: id?.platform
    };
    this.premise = {};

    //get premise
    const res = await callRemoteMethod({
      endpoint: CONSTANTS.URL.GET_PREMISE,
      type: "GET",
      data,
    });
    await this.getToken();
    runInAction(() => {
      this.premise = {
        ...res.result,
      };
    });
    return res?.result;
  });

  getRegistarationDetails = ErrorWrapper(async (data: any) => {
    const { personId, sewerageId, uaepassFlag } = data;

    //get premise
    try {
      const res = await callRemoteMethod({
        endpoint: CONSTANTS.URL.GET_REGISTRATION_DETAILS(
          personId,
          sewerageId,
          uaepassFlag
        ),
        type: "GET",
      });
      await this.getToken();
      runInAction(() => {
        this.registrationDetails = res.result;
        this.otpUserData = res?.result;
      });
      return res;
    } catch (error: any) {
      return error?.error[0]?.message;
    }
  });

  getNotificationConfig = ErrorWrapper(async () => {
    //get premise
    const res = await callRemoteMethod({
      endpoint: CONSTANTS.URL.NOTIFICATION_CONFIG,
      type: "GET",
    });
    // await this.getToken();
    runInAction(() => {
      this.notificationConfig = res?.result;
    });
    return res;
  });

  getRegistarationStatus = ErrorWrapper(async (data: any) => {
    const { personId } = data;

    const res = await callRemoteMethod({
      endpoint: CONSTANTS.URL.GET_REGISTRATION_STATUS(personId),
      type: "GET",
    });
    runInAction(() => {
      this.registrationStatus = res.result;
    });
    return res;
  });

  getPersonUsername = async (userId: any) => {
    const userNameRes: any = await User.userNameRes(userId);
    runInAction(() => {
      this.premise = {
        ...this.premise,
        username: userNameRes?.result?.userName,
        personId: userNameRes?.result?.personId,
      };
    });
    return userNameRes?.result;
  };

  getPremiseNumber = ErrorWrapper(async (id: string) => {
    const data = {
      premiseId: id,
    };

    this.premise = {};

    const res = await callRemoteMethod({
      endpoint: CONSTANTS.URL.GET_PREMISE,
      type: "GET",
      data,
    });

    runInAction(() => {
      this.premise = res.result;
    });
  });

  getPersonUserName = ErrorWrapper(async (personId: string) => {
    const data = {
      personId,
    };

    this.premise = { ...this.premise, username: null };

    const res = await callRemoteMethod({
      endpoint: CONSTANTS.URL.GET_USERNAME,
      type: "GET",
      data,
    });

    runInAction(() => {
      this.premise = { ...this.premise, username: res.result.username };
    });
  });

  getHappinessCenterTimeSlots = ErrorWrapper(async (data: any) => {
    const { date, branchNo } = data;

    const res = await callRemoteMethod({
      endpoint: CONSTANTS.URL.GET_HAPPINESS_TIMESLOT(branchNo, date),
      type: "GET",
    });
    return res;
  });

  getHappinessCenters = ErrorWrapper(async () => {
    const res = await callRemoteMethod({
      endpoint: CONSTANTS.URL.GET_HAPPINESS,
      type: "GET",
    });
    return res;
  });

  getHappinessCentersHelp = ErrorWrapper(async (data: any) => {
    const { branchNo } = data;
    const res = await callRemoteMethod({
      endpoint: CONSTANTS.URL.GET_HAPPINESS_HELP(branchNo),
      type: "GET",
    });

    return res;
  });
  //TODO: b7attela 2aw la2
  getToken = async () => {
    const data = {
      clientId: "ajman-sewerage",
      secret: "33cdc4b5a0e94c6f905b58e66931905d",
    };

    const res = await callRemoteMethod({
      endpoint: CONSTANTS.URL.FETCH_TOKEN,
      type: "POST",
      data,
    });

    runInAction(() => {
      this.token = res.result.token;
    });
  };

  sendOTP = ErrorWrapper(
    async ({
      premiseId,
      email,
      mobile,
      personID,
      transactionId,
      operation,
      // useProvidedContactInfo,
      isEditFlow,
    }: {
      premiseId: string;
      email: string;
      mobile: string;
      personID: string;
      transactionId: string;
      operation: number;
      isEditFlow?: boolean;
      // useProvidedContactInfo: boolean;
    }) => {
      const data = {
        mode:
          email && mobile
            ? "both"
            : mobile
            ? "mobile"
            : email
            ? "email"
            : personID
            ? "personID"
            : "mobile",
        personID,
        email: operation == 6?null:email,
        mobile: operation == 6 ? null:mobile, //.replaceAll('-', '')
        premiseID: premiseId,
        transactionId,
        operation,
        // useProvidedContactInfo,
      };

      const res = await callRemoteMethod({
        endpoint: CONSTANTS.URL.SEND_OTP,
        type: "POST",
        data,
      });
      this.otp = res.result.otp;
    }
  );

  verifyOTP = ErrorWrapper(
    async ({
      numbers,
      transactionId,
      operation
    }: {
      numbers: string;
      transactionId: string;
      operation: number;
    }) => {
      const data = {
        oneTimePasswordConfirm: numbers,
        otp: this.otp,
        transactionId: transactionId,
       operation
      };

      const res = await callRemoteMethod({
        endpoint: CONSTANTS.URL.VERIFY_OTP,
        type: "POST",
        data,
      });

      runInAction(() => {
        this.otpResult = res.result;
      });
      return res;
    }
  );

  verifyOTPRegistration = ErrorWrapper(async (dataOtp: any) => {
    const { numbers, personID, transactionId, operation } = dataOtp;
    const data = {
      OneTimePasswordConfirm: numbers,
      OTP: this.otp,
      IsMoveIn: true,
      PersonId: personID,
      transactionId: transactionId,
      operation: operation,
    };

    const res = await callRemoteMethod({
      endpoint: CONSTANTS.URL.VERIFY_OTP_REGISTRATION,
      type: "POST",
      data,
    });

    runInAction(() => {
      this.otpResult = res.result;
      console.log(res?.result,"otp res");
      this.otpUserData = res?.result?.user;
    });
    return res;
  });

  initializeUserOtpData = (data: any, premiseData: any) => {
    if (User?.info?.personId) {
      runInAction(() => {
        this.premise = premiseData;
      });
    } else {
      runInAction(() => {
        this.otpUserData = data;
        this.premise = premiseData;
      });
    }
  };

  initializeDataforUaePass = (data: any) => {
    runInAction(() => {
      this.otpUserData = data;
    });
  };
  verifyRefundOTP = ErrorWrapper(
    async ({
      numbers,
      transactionId,
    }: {
      numbers: string;
      transactionId: string;
    }) => {
      const data = {
        oneTimePasswordConfirm: numbers,
        transactionId: transactionId,
        otp: this.otp,
      };

      const res = await callRemoteMethod({
        endpoint: CONSTANTS.URL.VERIFY_OTP_REFUND,
        type: "POST",
        data,
      });

      runInAction(() => {
        this.otpResult = res.result;
      });
      return res;
    }
  );

  validateAjmanLc = ErrorWrapper(async (id: any) => {
    const data = id;

    const res = await callRemoteMethod({
      endpoint: CONSTANTS.URL.VALIDATE_AJMAN_LC,
      type: "POST",
      data,
    });
    runInAction(() => {
      this.ajmanUser =
        res.getTransactionInfoResponse?.getTransactionInfoResult?.newDataSet?.transactionStatus;
    });
    return res;
  });

  validateMakani = ErrorWrapper(async (makaniNumber: string) => {
    const res = await callRemoteMethod({
      endpoint: CONSTANTS.URL.VALIDATE_MAKANI(makaniNumber),
    });

    runInAction(() => {
      this.makani = res.result;
    });
    return res;
  });

  validateEmirateId = ErrorWrapper(async (data: any) => {
    //service/MakaniNumber/<makaninumber>
    const { id, brand } = data;
    const res = await callRemoteMethod({
      endpoint: CONSTANTS.URL.VALIDATE_EMIRATE_ID(id),
    });

    runInAction(() => {
      this.emirate = res.result;
    });
    return res;
  });

  validateFZ = ErrorWrapper(async (data: any) => {
    //service/MakaniNumber/<makaninumber>
    const { id, brand } = data;
    const res = await callRemoteMethod({
      endpoint: CONSTANTS.URL.VALIDATE_FZ(id, brand),
    });
    runInAction(() => {
      this.fzUser = res;
    });
    console.log(res);
    return res;
  });
  gracePeriod = ErrorWrapper(async () => {
    const res = await callRemoteMethod({
      endpoint: CONSTANTS.URL.GRACE_PERIOD,
    });

    return res;
  });

  fetchDashboardWidgets = ErrorWrapper(async () => {
    const res = await callRemoteMethod({
      endpoint: CONSTANTS.URL.DASHBOARD_WIDGETS,
    });

    runInAction(() => {
      this.dashboard = res.result.output;
    });
  });

  //TODO: b7attela walla la2 ?
  getCodeLabels = async () => {
    const res = await callRemoteMethod({ endpoint: CONSTANTS.URL.RESOURCES });
    setValues(res.result);

    runInAction(() => {
      this.codeLabels = res.result;
    });
    return res;
  };

  payment3DS = ErrorWrapper(async (dataObj: any) => {
    let { info } = await User;
    // alert(info?.token)
    return new Promise((resolve, reject) => {
      // Create headers object with the token
      const headers = {
        Authorization: `Bearer ${info?.token}`, // Assuming it's a JWT token
      };

      axios
        .post(
          CONSTANTS.URL.PAYMENT_BILL_UPDATE,
          {
            ...dataObj,
            platform: dataObj.type == 6? 'Autopay': 'Web',
          },
          {
            headers: {
              Authorization: `Bearer ${info?.token}`, // Adding the info?.token to the request headers
              CurrentLanguage: localStorage.getItem("settingUplanguage") ?? "en-US",
            },
          }
        )
        .then((response: any) => {
          resolve(response);
          console.log(response);
          runInAction(() => {
            this.paymentUpdateResponse = {
              result: response?.data?.result,
              isError: false,
            };
          });
        })
        .catch((error) => {
          const originalString = error?.response?.data?.error[0]?.message;
          const modifiedString = originalString.replace(/<br>/g, "");
          runInAction(() => {
            this.paymentUpdateResponse = {
              ...this.paymentUpdateResponse,
              isError: true,
              errorMessage: modifiedString,
            };
          });
          reject(error);
        });
    });
  });

  externalPayment3DS = ErrorWrapper(async (dataObj: any) => {

    let { info } = await User;
    const apiUrl = CONSTANTS.URL.NI_PAYMENT_BILL_UPDATE; 
console.log("Authorization Token Status:", info?.token ? "AVAILABLE" : "MISSING or UNDEFINED");
    console.log("Token Value (First 10 chars):", info?.token ? info.token.substring(0, 10) + '...' : 'N/A');

    return new Promise((resolve, reject) => {
        axios
            .post(apiUrl, { 
                ...dataObj,
                platform: "Web",
            }, {
                headers: {
                    Authorization: `Bearer ${info?.token}`
                }
            })
            .then((response: any) => {
                
                // Note: We use paymentUpdateResponse to store the result, 
                // as your PaymentResult component relies on this object.
                runInAction(() => {
                    this.paymentUpdateResponse = {
                        result: response?.data?.result,
                        isError: false,
                    };
                });
                resolve(response);
            })
            .catch((error) => {
                const originalString = error?.response?.data?.error[0]?.message;
                const modifiedString = originalString.replace(/<br>/g, '');
                runInAction(() => {
                    this.paymentUpdateResponse = {
                        ...this.paymentUpdateResponse,
                        isError: true,
                        errorMessage: modifiedString,
                    };
                });
                reject(error);
            });
    });
});

 TabbyPayment3DS = ErrorWrapper(async (dataObj: any) => {

    let { info } = await User;
    const apiUrl = CONSTANTS.URL.TABBY_PAYMENT_BILL_UPDATE; 
console.log("Authorization Token Status:", info?.token ? "AVAILABLE" : "MISSING or UNDEFINED");
    console.log("Token Value (First 10 chars):", info?.token ? info.token.substring(0, 10) + '...' : 'N/A');

    return new Promise((resolve, reject) => {
        axios
            .post(apiUrl, { 
                ...dataObj,
                platform: "Web",
            }, {
                headers: {
                    Authorization: `Bearer ${info?.token}`
                }
            })
            .then((response: any) => {
                
                // Note: We use paymentUpdateResponse to store the result, 
                // as your PaymentResult component relies on this object.
                runInAction(() => {
                    this.paymentUpdateResponse = {
                        result: response?.data?.result,
                        isError: false,
                    };
                });
                resolve(response);
            })
            .catch((error) => {
                const originalString = error?.response?.data?.error[0]?.message;
                const modifiedString = originalString.replace(/<br>/g, '');
                runInAction(() => {
                    this.paymentUpdateResponse = {
                        ...this.paymentUpdateResponse,
                        isError: true,
                        errorMessage: modifiedString,
                    };
                });
                reject(error);
            });
    });
});

TamaraPayment3DS = ErrorWrapper(async (dataObj: any) => {

    let { info } = await User;
    const apiUrl = CONSTANTS.URL.TAMARA_PAYMENT_BILL_UPDATE; 

    return new Promise((resolve, reject) => {
        axios
            .post(apiUrl, { 
                ...dataObj,
                platform: "Web",
            }, {
                headers: {
                    Authorization: `Bearer ${info?.token}`
                }
            })
            .then((response: any) => {
                
                // Note: We use paymentUpdateResponse to store the result, 
                // as your PaymentResult component relies on this object.
                runInAction(() => {
                    this.paymentUpdateResponse = {
                        result: response?.data?.result,
                        isError: false,
                    };
                });
                resolve(response);
            })
            .catch((error) => {
                const originalString = error?.response?.data?.error[0]?.message;
                const modifiedString = originalString.replace(/<br>/g, '');
                runInAction(() => {
                    this.paymentUpdateResponse = {
                        ...this.paymentUpdateResponse,
                        isError: true,
                        errorMessage: modifiedString,
                    };
                });
                reject(error);
            });
    });
});

  getDashRecentRequests = ErrorWrapper(async (personId: string) => {
    const res = await callRemoteMethod({
      endpoint: CONSTANTS.URL.RECENT_REQUESTS,
      type: "GET",
      data: { personId },
    });

    runInAction(() => {
      this.recentRequests = res.result.output.requestList;
    });
  });

  getDashCommonlyUsedServices = ErrorWrapper(async (personId: string) => {
    const currentLan: any =
      localStorage.getItem("settingUplanguage") ?? "en-US";
    const res = await callRemoteMethod({
      endpoint: CONSTANTS.URL.COMMONLY_USED_SERVICES(currentLan),
      type: "GET",
    });

    runInAction(() => {
      this.commonlyUsedServices = res.data;
    });
  });

  incrementServiceUsage = async (serviceId: string) => {
    try {
      await callRemoteMethod({
        endpoint: CONSTANTS.URL.INCREMENT_SERVICE_USAGE(serviceId),
        type: "POST",
      });
    } catch (err) {
      console.log(err);
    }
  };

  getServices = ErrorWrapper(async () => {
    const currlan = localStorage.getItem("settingUplanguage");
    //TODO: add language
    const res = await callRemoteMethod({
      endpoint: CONSTANTS.URL.SERVICES + `?${currlan}`,
    });

    runInAction(() => {
      this.services = res.data;
    });
  });

  getNotifications = ErrorWrapper(
    async ({ start, perPage }: { start: number; perPage: number }) => {
      const date = moment(Date.now()).format("YYYY-MM-DD");

      const specificDate = moment(date);
      const numberOfDays: any = specificDate
        .clone()
        .subtract(this?.notificationConfig?.noOfDays, "days")
        .toDate();
      // const date = "0001-01-01";
      const res = await callRemoteMethod({
        endpoint: CONSTANTS.URL.NOTIFICATIONS(
          moment(numberOfDays).format("YYYY-MM-DD"),
          start,
          perPage
        ),
      });

      runInAction(() => {
        this.notifications.list = res.result?.output?.notificationList
          ? res.result?.output?.notificationList
          : [];
        this.latTimeStamp = res.result?.output?.lastTimeStamp;
      });
    }
  );

  getNotificationsCount = ErrorWrapper(async () => {
    const date = moment(Date.now()).format("YYYY-MM-DDTHH:mm:ss");
    const res = await callRemoteMethod({
      endpoint: CONSTANTS.URL.NOTIFICATIONS_COUNT(date),
    });

    runInAction(() => {
      this.notifications.count = Number(
        res.result.output.totalNumberOfNotifications
      );
    });
    return Number(res.result.output.totalNumberOfNotifications);
  });

  emailVerifyCodeForRegistration = ErrorWrapper(async (data: any) => {
    const { code, username } = data;
    const res = await callRemoteMethod({
      endpoint: CONSTANTS.URL.VERIFY_EMAIL_REGISTRATION,
      data: {
        code,
        username,
      },
    });
    return res.result;
  });   ownerServiceActivation = ErrorWrapper(async (payload: any) => {
      const data={
        premiseId:payload?.premiseId,
        otpData:{
          oneTimePasswordConfirm:payload?.otpData?.oneTimePasswordConfirm,
          otp:this.otp,
          personId:User?.profile?.personId,
          isMoveIn:true,
          transactionId:payload?.otpData?.transactionId,
        }
      }
      const res = await callRemoteMethod({
        endpoint: CONSTANTS.URL.OWNER_SERVICE_ACTIVATION,
        type: "POST",
        data,
      });
  
      return res?.result;
    });


}

const generalStore = new General();
export default generalStore;
